import { useTranslation } from "react-i18next"

import { SUPPORTED_LANGUAGES } from "src/i18n"

import "./LanguageSwitcher.css"

const LABELS = { en: "EN", es: "ES" }

// A segmented control: one button per language, the active one raised. Same shape as the game
// tabs' header, so it reads as a setting rather than a form.
const LanguageSwitcher = ({ className = "" }) => {
  const { t, i18n } = useTranslation()
  const active = SUPPORTED_LANGUAGES.includes(i18n.resolvedLanguage) ? i18n.resolvedLanguage : "en"

  return (
    <div className={`language-switcher ${className}`} role="group" aria-label={t("settings.language")}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          aria-pressed={lng === active}
          className={`language-option${lng === active ? " active" : ""}`}
          onClick={() => i18n.changeLanguage(lng)}
        >
          {LABELS[lng]}
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher
